import { TellescopeFormFieldBaseProps } from "../types";
import { Label } from "@tellescope/design-system";
import { Slider } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { FieldDescription } from "../FieldDescription";

export interface RatingFieldProps extends TellescopeFormFieldBaseProps<"rating"> {}

const parseDefault = (raw: string | undefined, fallback: number) => {
  if (raw === undefined) return fallback;
  const parsed = parseInt(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const RatingField = ({
  title,
  description,
  htmlDescription,
  value,
  onChange,
  onBlur,
  className,
  options,
  error,
  touched,
  disabled,
  required,
  autoFocus,
}: RatingFieldProps) => {
  const showError = !!(error && touched);

  const min = options?.from ?? 1;
  const max = options?.to ?? 10;
  const step = options?.rangeStepSize || 1;
  const defaultValue = parseDefault(options?.default, min);
  const sliderValue = value ?? defaultValue;

  return (
    <div className={cn("space-y-2", className)}>
      {title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground">{min}</span>
        <Slider
          value={[sliderValue]}
          onValueChange={(newVal) => onChange(newVal[0])}
          onBlur={onBlur}
          min={min}
          max={max}
          step={step}
          hideThumb={value === undefined}
          className="flex-1"
          disabled={disabled}
          autoFocus={autoFocus}
        />
        <span className="text-sm text-muted-foreground">{max}</span>
      </div>
      {value !== undefined && <div className="text-center text-sm text-muted-foreground">{value}</div>}
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
